import { render, staticRenderFns } from "./userSvg.vue?vue&type=template&id=b6d2282a&"
import script from "./userSvg.vue?vue&type=script&lang=js&"
export * from "./userSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports